import { OnInit } from '@angular/core';

/**
 * This mixin is meant to wrap current panel components so that input/ouput is
 * converted from the old static format `task_title: sample` to the new dynamic
 * format `fields.FieldID-123: sample`
 *
 * For wrapped components the source of truth is the fields array
 */
export function CreateCrmActivityMigrationMixin<T extends new (...args: any[]) => any>(Base: T) {
  return class extends Base implements OnInit {
    // Array of [oldKeys, newFieldIDs] tuples defining the field mappings.
    protected migratedKeys: [string, string][] = [];

    protected setOnInit(_: any): void {
      // Default implementation does nothing
    }

    protected setOnGetData(_: any): void {
      // Default implementation does nothing
    }

    ngOnInit(): void {
      if (this.step?.data) {
        const jsonData = JSON.parse(this.step.data);
        const fields = jsonData.fields || {};

        for (const [key, fieldId] of this.migratedKeys) {
          if (fields[fieldId]) {
            jsonData[key] = fields[fieldId];
          }
        }

        this.setOnInit(jsonData);
        this.step.data = JSON.stringify(jsonData);
      }

      super.ngOnInit();
    }

    getData(): any {
      const jsonData = super.getData();
      const fields: Record<string, any> = {};

      for (const [key, fieldId] of this.migratedKeys) {
        if (jsonData[key]) {
          fields[fieldId] = jsonData[key];
          delete jsonData[key];
        }
      }

      this.setOnGetData(jsonData);

      jsonData.fields = fields;
      return jsonData;
    }
  };
}
